import React from "react";

const SvgEtcReserv = (props) => {
  const fillColor = props.fill || "#16161D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_0_39)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.8026 12.1987C15.8855 12.2216 15.9638 12.2586 16.034 12.308L16.0641 12.3315C16.2207 12.4538 16.3224 12.6333 16.3468 12.8306C16.3712 13.0278 16.3162 13.2267 16.1941 13.3835L11.5142 19.3833C11.4455 19.4713 11.358 19.5428 11.2581 19.5927C11.1581 19.6425 11.0484 19.6695 10.9367 19.6715C10.8251 19.6735 10.7144 19.6505 10.6128 19.6043C10.5112 19.5581 10.4211 19.4897 10.3492 19.4043L7.82936 16.4043L7.82583 16.4004C7.75838 16.3256 7.70668 16.238 7.67383 16.1428C7.64098 16.0476 7.62764 15.9467 7.63461 15.8463C7.64158 15.7458 7.66872 15.6477 7.7144 15.558C7.76009 15.4682 7.82338 15.3886 7.90051 15.3238C7.97764 15.259 8.06703 15.2105 8.16334 15.181C8.25965 15.1515 8.36091 15.1417 8.46108 15.1523C8.56125 15.1628 8.65827 15.1933 8.74637 15.2422C8.83446 15.291 8.91174 15.3571 8.97375 15.4365L10.9012 17.7304L15.0111 12.4603C15.0717 12.3826 15.147 12.3176 15.2327 12.269C15.3184 12.2204 15.4129 12.1892 15.5107 12.1771C15.6085 12.1651 15.7077 12.1724 15.8026 12.1987Z"
          fill="#4E4E4E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.83203 0.90329C5.24624 0.90329 5.58203 1.23908 5.58203 1.65329V3.7236H18.4297V1.65329C18.4297 1.23908 18.7655 0.90329 19.1797 0.90329C19.5939 0.90329 19.9297 1.23908 19.9297 1.65329V3.7236H21.8963C22.8352 3.7236 23.5963 4.48473 23.5963 5.42362V21.392C23.5963 22.3309 22.8352 23.092 21.8963 23.092H2.09845C1.15956 23.092 0.398438 22.3309 0.398438 21.392V5.42362C0.398438 4.48473 1.15956 3.7236 2.09845 3.7236H4.08203V1.65329C4.08203 1.23908 4.41782 0.90329 4.83203 0.90329ZM22.0963 8.69626V5.42362C22.0963 5.31315 22.0067 5.2236 21.8963 5.2236H2.09845C1.98799 5.2236 1.89844 5.31315 1.89844 5.42362V8.69626H22.0963ZM1.89844 10.2008H22.0963V21.392C22.0963 21.5024 22.0067 21.592 21.8963 21.592H2.09845C1.98799 21.592 1.89844 21.5024 1.89844 21.392V10.2008Z"
          fill="#4E4E4E"
        />
      </g>
      <defs>
        <clipPath id="clip0_0_39">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgEtcReserv;
